import cogoToast from "cogo-toast";
import { useEffect, useState } from "react";
import { useSetCookieMutation } from "../../../../../redux/apiSlice";
import OverviewSkeleton from "./OverviewSkeleton";


const Overview = _ => {

    const [setCookie, { data, error}] = useSetCookieMutation();
    const [frameLoaded, setFrameLoaded] = useState(false);

    useEffect(() => {
        if (error) {
            cogoToast.error(error.data)
        }
    }, [error]);

    useEffect(_ => {
        setCookie();
    }, [setCookie]);

    if (!data){
        return <OverviewSkeleton className="px-4 py-5" />
    }

    return  <div >
                <div className="card card-custom card-stretch">
                    <div className="card-body px-4 py-5" >
                        <iframe  
                            onLoad={_ => setFrameLoaded(!!data?.url)} 
                            className={`w-100 border-0 ${frameLoaded ? "" : "d-none"}`}
                            src={data.url}
                            style={{minHeight: "calc(100vh - 70px)"}}
                            title="Overview"
                        ></iframe>
                        <OverviewSkeleton className={frameLoaded ? "d-none" : ""} />
                    </div>
                </div>
            </div>
}

export default Overview;